import React from "react";
import styled from "styled-components";
import logo from './logo.png'

const Footer = () => {
  return (
    <FooterContainer>
      <a href="https://portofoliulmeu.netlify.app/" rel="noreferrer" target="_blank"> 
         <img src={logo} alt="logo" /> 
       </a>


    </FooterContainer>
  );
};

const FooterContainer = styled.div`
  img {
    height: 50px;
    width: 80px;
  }
`;

export default Footer;
